// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Pages Component Styles */

.Pages-main {
    min-height: calc(100vh - 70px);
    padding: 40px 60px;
    background: #ffffff;
    margin-top: 70px;
}

/* Breadcrumb Navigation */
.pagesBreadcrumb {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 30px;
    font-size: 14px;
}

.breadcrumbLink {
    color: #667eea;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
    text-decoration: none;
    padding: 4px 8px;
    border-radius: 6px;
}

.breadcrumbLink:hover {
    color: #764ba2;
    background: rgba(102, 126, 234, 0.1);
    transform: translateY(-1px);
}

.breadcrumbCurrent {
    color: #6b7280;
    font-weight: 400;
}

.breadcrumbArrow {
    font-size: 12px !important;
    color: #9ca3af !important;
}

/* Sidebar Card */
.pagesSidebarCard {
    background: #ffffff !important;
    border: 1px solid rgba(102, 126, 234, 0.1) !important;
    border-radius: 16px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
    height: fit-content;
    position: sticky;
    top: 90px;
}

.pagesSidebarCard .ant-card-body {
    padding: 20px !important;
}

.pagesSidebarHeader {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.pagesSidebarIcon {
    font-size: 24px !important;
    color: #667eea !important;
}

.pagesSidebarTitle {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
}

.pagesSidebarMenu {
    max-height: calc(100vh - 250px);
    overflow-y: auto;
}

.pagesSidebarMenu::-webkit-scrollbar {
    width: 6px;
}

.pagesSidebarMenu::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 3px;
}

.pagesSidebarMenu::-webkit-scrollbar-thumb:hover {
    background-color: #94a3b8;
}

.pagesMenu {
    border: none !important;
}

.pagesMenu .ant-menu-item {
    border-radius: 8px !important;
    margin: 4px 0 !important;
    padding: 12px 16px !important;
    height: auto !important;
    line-height: 1.5 !important;
}

.pagesMenu .ant-menu-item:hover {
    background: rgba(102, 126, 234, 0.08) !important;
}

.pagesMenu .ant-menu-item-selected {
    background: rgba(102, 126, 234, 0.15) !important;
    color: #667eea !important;
    font-weight: 600 !important;
}

.pagesMenu .ant-menu-item-selected::after {
    display: none !important;
}

/* Content Card */
.pagesContentCard {
    background: #ffffff !important;
    border: 1px solid rgba(102, 126, 234, 0.1) !important;
    border-radius: 16px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
    min-height: 600px;
}

.pagesContentCard .ant-card-body {
    padding: 32px !important;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

/* Content Header */
.pagesContentHeader {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 32px;
    padding-bottom: 24px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.pagesContentHeaderIcon {
    width: 64px;
    height: 64px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.contentTypeIcon {
    font-size: 32px !important;
    color: #667eea !important;
}

.contentTypeIcon.videoIcon {
    color: #667eea !important;
}

.pagesContentHeaderIcon .videoIcon {
    color: #667eea !important;
}

.pagesContentHeaderIcon {
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
    border: 1px solid rgba(102, 126, 234, 0.2);
}

.contentTypeIcon.documentIcon {
    color: #f5576c !important;
}

.pagesContentHeaderIcon .documentIcon {
    color: #f5576c !important;
}

.pagesContentHeaderIcon.documentIconWrapper {
    background: linear-gradient(135deg, rgba(245, 87, 108, 0.1) 0%, rgba(239, 68, 68, 0.1) 100%);
    border: 1px solid rgba(245, 87, 108, 0.2);
}

.contentTypeIcon.audioIcon {
    color: #10b981 !important;
}

.pagesContentHeaderIcon .audioIcon {
    color: #10b981 !important;
}

.pagesContentHeaderIcon.audioIconWrapper {
    background: linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.1) 100%);
    border: 1px solid rgba(16, 185, 129, 0.2);
}

.pagesContentHeaderInfo {
    flex: 1 1;
}

.pagesMaterialTitle {
    font-size: 28px;
    font-weight: 700;
    color: #1f2937;
    margin: 0 0 8px 0;
    line-height: 1.3;
}

.pagesMaterialType {
    display: inline-block;
    padding: 4px 12px;
    background: rgba(102, 126, 234, 0.1);
    color: #667eea;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* Video Container */
.pagesVideoContainer {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.pagesVideoWrapper {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%; /* 16:9 aspect ratio */
    background: #000;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.pagesVideoPlayer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

/* Audio Container */
.pagesAudioContainer {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.pagesAudioWrapper {
    background: linear-gradient(135deg, rgba(16, 185, 129, 0.05) 0%, rgba(5, 150, 105, 0.05) 100%);
    border: 1px solid rgba(16, 185, 129, 0.2);
    border-radius: 12px;
    padding: 40px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.pagesAudioPlayerContainer {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.pagesAudioPlayer {
    width: 100%;
}

/* Document Container */
.pagesDocumentContainer {
    display: flex;
    flex-direction: column;
    gap: 24px;
    min-height: 0;
    flex:1 1;
}

.pagesDocumentWrapper {
    height: 50vh;
    overflow-y: auto;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    background: #f9fafb;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    min-height: 0;
    flex:1 1;
}

.pagesDocumentWrapper::-webkit-scrollbar {
    width: 8px;
}

.pagesDocumentWrapper::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 4px;
}

.pagesDocumentWrapper::-webkit-scrollbar-thumb:hover {
    background-color: #94a3b8;
}

/* PDF Viewer Styles */
.rpv-core__viewer {
    background-color: #ffffff !important;
}

.rpv-core__page-layer {
    margin: 0 !important;
    padding: 0 !important;
    box-shadow: none !important;
}

.rpv-core__inner-page {
    margin: 0 !important;
    padding: 0 !important;
}

.rpv-core__canvas-layer {
    display: block;
    margin: 0 auto !important;
}

.rpv-core__text-layer {
    display: none;
}

/* Completion Section */
.pagesCompletionSection {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 32px;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
    border-radius: 12px;
    border: 1px solid rgba(102, 126, 234, 0.2);
}

.pagesCompletionCheckbox {
    font-size: 16px;
    font-weight: 500;
    color: #1f2937;
}

.pagesCompletionCheckbox .ant-checkbox {
    margin-right: 12px;
}

.pagesCompletionCheckbox .ant-checkbox-inner {
    width: 20px;
    height: 20px;
    border-color: #667eea;
}

.pagesCompletionCheckbox .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #667eea;
    border-color: #667eea;
}

.pagesSubmitButton {
    height: 48px;
    padding: 0 32px;
    font-size: 16px;
    font-weight: 600;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    border: none !important;
    border-radius: 12px !important;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4) !important;
    transition: all 0.3s ease !important;
}

.pagesSubmitButton:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5) !important;
}

.pagesSubmitButton:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Loader */
.pagesLoader {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
}

/* Legacy Styles (for compatibility) */
.back {
    display: none;
}

.MaterialName {
    display: none;
}

.Doc {
    display: none;
}

.videoDiv {
    display: none;
}

.Slider {
    display: none;
}

/*Pdf overlay*/
.pagesDocumentWrapper {
  height: 75vh;
  position: relative;
}

.pagesPdfLoader {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.96) 0%,
    rgba(248, 250, 252, 0.96) 100%
  );
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  z-index: 10;
}

/* Spinner color override */
.pagesPdfLoader .ant-spin-dot-item {
  background-color: #667eea;
}

/* Loading text */
.pagesPdfLoader p {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #667eea;
  letter-spacing: 0.3px;
  animation: pdfFadePulse 1.6s ease-in-out infinite;
}

/* Subtle pulse animation */
@keyframes pdfFadePulse {
  0% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.4;
  }
}



/* Responsive Design */
@media (max-width: 1200px) {
    .Pages-main {
        padding: 30px 40px;
    }
}

@media (max-width: 768px) {
    .Pages-main {
        padding: 30px 20px;
    }

    .pagesContentCard .ant-card-body {
        padding: 24px !important;
    }

    .pagesContentHeader {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }

    .pagesMaterialTitle {
        font-size: 24px;
    }

    .pagesVideoWrapper {
        padding-bottom: 56.25%;
    }

    .pagesDocumentWrapper {
        height: 60vh;
    }

    .pagesSidebarCard {
        position: relative;
        top: 0;
        margin-bottom: 24px;
    }
}

@media (max-width: 480px) {
    .Pages-main {
        padding: 20px 16px;
    }

    .pagesMaterialTitle {
        font-size: 20px;
    }

    .pagesContentHeaderIcon {
        width: 56px;
        height: 56px;
    }

    .contentTypeIcon {
        font-size: 28px !important;
    }

    .pagesCompletionSection {
        padding: 24px 16px;
    }

    .pagesSubmitButton {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Pages/Pages.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,8BAA8B;IAC9B,qDAAqD;IACrD,8BAA8B;IAC9B,qDAAqD;IACrD,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,wBAAwB;IACxB,6BAA6B;IAC7B,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;IAChD,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,iBAAiB;AACjB;IACI,8BAA8B;IAC9B,qDAAqD;IACrD,8BAA8B;IAC9B,qDAAqD;IACrD,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8FAA8F;IAC9F,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4FAA4F;IAC5F,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4FAA4F;IAC5F,yCAAyC;AAC7C;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,oCAAoC;IACpC,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,sBAAsB,EAAE,sBAAsB;IAC9C,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,8FAA8F;IAC9F,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,WAAW;AACf;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,QAAM;AACV;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,qCAAqC;IACrC,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,QAAM;AACV;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,gGAAgG;IAChG,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,wEAAwE;IACxE,uBAAuB;IACvB,8BAA8B;IAC9B,0DAA0D;IAC1D,oCAAoC;AACxC;;AAEA;IACI,2BAA2B;IAC3B,0DAA0D;AAC9D;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,sCAAsC;AACtC;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA,cAAc;AACd;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT;;;;GAIC;EACD,kCAA0B;UAA1B,0BAA0B;EAC1B,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA,2BAA2B;AAC3B;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;;;AAIA,sBAAsB;AACtB;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":["/* Modern Pages Component Styles */\n\n.Pages-main {\n    min-height: calc(100vh - 70px);\n    padding: 40px 60px;\n    background: #ffffff;\n    margin-top: 70px;\n}\n\n/* Breadcrumb Navigation */\n.pagesBreadcrumb {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 30px;\n    font-size: 14px;\n}\n\n.breadcrumbLink {\n    color: #667eea;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-weight: 500;\n    text-decoration: none;\n    padding: 4px 8px;\n    border-radius: 6px;\n}\n\n.breadcrumbLink:hover {\n    color: #764ba2;\n    background: rgba(102, 126, 234, 0.1);\n    transform: translateY(-1px);\n}\n\n.breadcrumbCurrent {\n    color: #6b7280;\n    font-weight: 400;\n}\n\n.breadcrumbArrow {\n    font-size: 12px !important;\n    color: #9ca3af !important;\n}\n\n/* Sidebar Card */\n.pagesSidebarCard {\n    background: #ffffff !important;\n    border: 1px solid rgba(102, 126, 234, 0.1) !important;\n    border-radius: 16px !important;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;\n    height: fit-content;\n    position: sticky;\n    top: 90px;\n}\n\n.pagesSidebarCard .ant-card-body {\n    padding: 20px !important;\n}\n\n.pagesSidebarHeader {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 20px;\n    padding-bottom: 16px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.pagesSidebarIcon {\n    font-size: 24px !important;\n    color: #667eea !important;\n}\n\n.pagesSidebarTitle {\n    font-size: 18px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0;\n}\n\n.pagesSidebarMenu {\n    max-height: calc(100vh - 250px);\n    overflow-y: auto;\n}\n\n.pagesSidebarMenu::-webkit-scrollbar {\n    width: 6px;\n}\n\n.pagesSidebarMenu::-webkit-scrollbar-thumb {\n    background-color: #cbd5e1;\n    border-radius: 3px;\n}\n\n.pagesSidebarMenu::-webkit-scrollbar-thumb:hover {\n    background-color: #94a3b8;\n}\n\n.pagesMenu {\n    border: none !important;\n}\n\n.pagesMenu .ant-menu-item {\n    border-radius: 8px !important;\n    margin: 4px 0 !important;\n    padding: 12px 16px !important;\n    height: auto !important;\n    line-height: 1.5 !important;\n}\n\n.pagesMenu .ant-menu-item:hover {\n    background: rgba(102, 126, 234, 0.08) !important;\n}\n\n.pagesMenu .ant-menu-item-selected {\n    background: rgba(102, 126, 234, 0.15) !important;\n    color: #667eea !important;\n    font-weight: 600 !important;\n}\n\n.pagesMenu .ant-menu-item-selected::after {\n    display: none !important;\n}\n\n/* Content Card */\n.pagesContentCard {\n    background: #ffffff !important;\n    border: 1px solid rgba(102, 126, 234, 0.1) !important;\n    border-radius: 16px !important;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;\n    min-height: 600px;\n}\n\n.pagesContentCard .ant-card-body {\n    padding: 32px !important;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n}\n\n/* Content Header */\n.pagesContentHeader {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 32px;\n    padding-bottom: 24px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.pagesContentHeaderIcon {\n    width: 64px;\n    height: 64px;\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.contentTypeIcon {\n    font-size: 32px !important;\n    color: #667eea !important;\n}\n\n.contentTypeIcon.videoIcon {\n    color: #667eea !important;\n}\n\n.pagesContentHeaderIcon .videoIcon {\n    color: #667eea !important;\n}\n\n.pagesContentHeaderIcon {\n    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\n    border: 1px solid rgba(102, 126, 234, 0.2);\n}\n\n.contentTypeIcon.documentIcon {\n    color: #f5576c !important;\n}\n\n.pagesContentHeaderIcon .documentIcon {\n    color: #f5576c !important;\n}\n\n.pagesContentHeaderIcon.documentIconWrapper {\n    background: linear-gradient(135deg, rgba(245, 87, 108, 0.1) 0%, rgba(239, 68, 68, 0.1) 100%);\n    border: 1px solid rgba(245, 87, 108, 0.2);\n}\n\n.contentTypeIcon.audioIcon {\n    color: #10b981 !important;\n}\n\n.pagesContentHeaderIcon .audioIcon {\n    color: #10b981 !important;\n}\n\n.pagesContentHeaderIcon.audioIconWrapper {\n    background: linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.1) 100%);\n    border: 1px solid rgba(16, 185, 129, 0.2);\n}\n\n.pagesContentHeaderInfo {\n    flex: 1;\n}\n\n.pagesMaterialTitle {\n    font-size: 28px;\n    font-weight: 700;\n    color: #1f2937;\n    margin: 0 0 8px 0;\n    line-height: 1.3;\n}\n\n.pagesMaterialType {\n    display: inline-block;\n    padding: 4px 12px;\n    background: rgba(102, 126, 234, 0.1);\n    color: #667eea;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n/* Video Container */\n.pagesVideoContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.pagesVideoWrapper {\n    position: relative;\n    width: 100%;\n    padding-bottom: 56.25%; /* 16:9 aspect ratio */\n    background: #000;\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n}\n\n.pagesVideoPlayer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n/* Audio Container */\n.pagesAudioContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.pagesAudioWrapper {\n    background: linear-gradient(135deg, rgba(16, 185, 129, 0.05) 0%, rgba(5, 150, 105, 0.05) 100%);\n    border: 1px solid rgba(16, 185, 129, 0.2);\n    border-radius: 12px;\n    padding: 40px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.pagesAudioPlayerContainer {\n    background: #ffffff;\n    border-radius: 12px;\n    padding: 20px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.pagesAudioPlayer {\n    width: 100%;\n}\n\n/* Document Container */\n.pagesDocumentContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    min-height: 0;\n    flex:1;\n}\n\n.pagesDocumentWrapper {\n    height: 50vh;\n    overflow-y: auto;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    border-radius: 12px;\n    background: #f9fafb;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n    min-height: 0;\n    flex:1;\n}\n\n.pagesDocumentWrapper::-webkit-scrollbar {\n    width: 8px;\n}\n\n.pagesDocumentWrapper::-webkit-scrollbar-thumb {\n    background-color: #cbd5e1;\n    border-radius: 4px;\n}\n\n.pagesDocumentWrapper::-webkit-scrollbar-thumb:hover {\n    background-color: #94a3b8;\n}\n\n/* PDF Viewer Styles */\n.rpv-core__viewer {\n    background-color: #ffffff !important;\n}\n\n.rpv-core__page-layer {\n    margin: 0 !important;\n    padding: 0 !important;\n    box-shadow: none !important;\n}\n\n.rpv-core__inner-page {\n    margin: 0 !important;\n    padding: 0 !important;\n}\n\n.rpv-core__canvas-layer {\n    display: block;\n    margin: 0 auto !important;\n}\n\n.rpv-core__text-layer {\n    display: none;\n}\n\n/* Completion Section */\n.pagesCompletionSection {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n    padding: 32px;\n    background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);\n    border-radius: 12px;\n    border: 1px solid rgba(102, 126, 234, 0.2);\n}\n\n.pagesCompletionCheckbox {\n    font-size: 16px;\n    font-weight: 500;\n    color: #1f2937;\n}\n\n.pagesCompletionCheckbox .ant-checkbox {\n    margin-right: 12px;\n}\n\n.pagesCompletionCheckbox .ant-checkbox-inner {\n    width: 20px;\n    height: 20px;\n    border-color: #667eea;\n}\n\n.pagesCompletionCheckbox .ant-checkbox-checked .ant-checkbox-inner {\n    background-color: #667eea;\n    border-color: #667eea;\n}\n\n.pagesSubmitButton {\n    height: 48px;\n    padding: 0 32px;\n    font-size: 16px;\n    font-weight: 600;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n    border: none !important;\n    border-radius: 12px !important;\n    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4) !important;\n    transition: all 0.3s ease !important;\n}\n\n.pagesSubmitButton:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5) !important;\n}\n\n.pagesSubmitButton:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* Loader */\n.pagesLoader {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 400px;\n}\n\n/* Legacy Styles (for compatibility) */\n.back {\n    display: none;\n}\n\n.MaterialName {\n    display: none;\n}\n\n.Doc {\n    display: none;\n}\n\n.videoDiv {\n    display: none;\n}\n\n.Slider {\n    display: none;\n}\n\n/*Pdf overlay*/\n.pagesDocumentWrapper {\n  height: 75vh;\n  position: relative;\n}\n\n.pagesPdfLoader {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  background: linear-gradient(\n    135deg,\n    rgba(255, 255, 255, 0.96) 0%,\n    rgba(248, 250, 252, 0.96) 100%\n  );\n  backdrop-filter: blur(4px);\n  z-index: 10;\n}\n\n/* Spinner color override */\n.pagesPdfLoader .ant-spin-dot-item {\n  background-color: #667eea;\n}\n\n/* Loading text */\n.pagesPdfLoader p {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #667eea;\n  letter-spacing: 0.3px;\n  animation: pdfFadePulse 1.6s ease-in-out infinite;\n}\n\n/* Subtle pulse animation */\n@keyframes pdfFadePulse {\n  0% {\n    opacity: 0.4;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.4;\n  }\n}\n\n\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n    .Pages-main {\n        padding: 30px 40px;\n    }\n}\n\n@media (max-width: 768px) {\n    .Pages-main {\n        padding: 30px 20px;\n    }\n\n    .pagesContentCard .ant-card-body {\n        padding: 24px !important;\n    }\n\n    .pagesContentHeader {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 16px;\n    }\n\n    .pagesMaterialTitle {\n        font-size: 24px;\n    }\n\n    .pagesVideoWrapper {\n        padding-bottom: 56.25%;\n    }\n\n    .pagesDocumentWrapper {\n        height: 60vh;\n    }\n\n    .pagesSidebarCard {\n        position: relative;\n        top: 0;\n        margin-bottom: 24px;\n    }\n}\n\n@media (max-width: 480px) {\n    .Pages-main {\n        padding: 20px 16px;\n    }\n\n    .pagesMaterialTitle {\n        font-size: 20px;\n    }\n\n    .pagesContentHeaderIcon {\n        width: 56px;\n        height: 56px;\n    }\n\n    .contentTypeIcon {\n        font-size: 28px !important;\n    }\n\n    .pagesCompletionSection {\n        padding: 24px 16px;\n    }\n\n    .pagesSubmitButton {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
